import {
  GET_BLACKLISTS_FAIL,
  GET_BLACKLISTS_SUCCESS,
  GET_BLACKLIST_DETAIL_FAIL,
  GET_BLACKLIST_DETAIL_SUCCESS,
  ADD_BLACKLIST_SUCCESS,
  ADD_BLACKLIST_FAIL,
  UPDATE_BLACKLIST_SUCCESS,
  UPDATE_BLACKLIST_FAIL,
  CLEAR_MESSAGE,
} from "./actionTypes"

const INIT_STATE = {
  blacklistList: [],
  blacklistDetail: {},
  error: {},
  message: "",
}

const blacklists = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BLACKLISTS_SUCCESS:
      return {
        ...state,
        blacklistList: action.payload?.data,
      }

    case GET_BLACKLISTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_BLACKLIST_SUCCESS:
      return {
        ...state,
        blacklistList: [...state.blacklistList, action?.payload?.data || {}],
        message: action?.payload?.message || "",
      }

    case ADD_BLACKLIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BLACKLIST_DETAIL_SUCCESS:
      return {
        ...state,
        blacklistDetail: action.payload,
      }

    case UPDATE_BLACKLIST_SUCCESS:
      return {
        ...state,
        message: "Successfully blacklist updated!",
        blacklistList: state.blacklistList.map(blacklist => {
          return blacklist._id.toString() === action.payload?.data._id.toString()
            ? { blacklist, ...action.payload?.data }
            : blacklist
        }),
      }

    case UPDATE_BLACKLIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BLACKLIST_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    default:
      return state
  }
}

export default blacklists
